import { observer } from "mobx-react";
import FontBody1 from "../../../../../../../../../components/fonts/font-body1/font-body1";
import { Input } from "../../../../../../../../../components/inputs/input/input";
import { IOption, SelectDropdown } from "../../../../../../../../../components/inputs/select-dropdown/select-dropdown";
import { Tooltip } from "../../../../../../../../../components/tooltip/tooltip";
import FontBody2 from "../../../../../../../../../components/fonts/font-body2/font-body2";
import { FONT_COLOR } from "../../../../../../../../../components/fonts/font-props";
import IconInfo from "../../../../../../../../../components/icons/icon-info/icon-info";
import Icon from "../../../../../../../../../components/icons/icon/icon";
import { ICompareValueTypeComponentProps } from "../condition-field";
import WindowCompareValueStore from "../../../../../../../stores/compare-value/window-compare-value-store";

const WindowCompareValueField: React.FC<ICompareValueTypeComponentProps> = observer(({store, condition, operatorSelector}) => {
    const compareValueStore: WindowCompareValueStore = store as WindowCompareValueStore;

    const typeOptions = compareValueStore.options as IOption[];
    const selectedType = typeOptions.find(o => o.value === compareValueStore.type);

    return (
        <>
            {operatorSelector}

            <Input disabled={!condition.isEditMode} type={`number`} min={0} minlength={3} value={compareValueStore.value} onChange={(v) => compareValueStore.setValue(v as number)} placeholder="0" />

            <SelectDropdown disabled={!condition.isEditMode} value={selectedType} options={typeOptions} onChange={(o) => compareValueStore.setType(o?.value.toString() ?? '')} isSearchable={false} />

            <FontBody1>before the return request</FontBody1>
            
            {condition.tooltip && (
                <Tooltip content={<div style={{ maxWidth: '200px' }}>
                    <FontBody2 color={FONT_COLOR.NEUTRAL_WHITE}>
                        {condition.tooltip}
                    </FontBody2>
                </div>}>
                    <Icon Component={IconInfo} />
                </Tooltip>
            )}
        </>
    );
});

export default WindowCompareValueField;